import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useMiniChatShallowStore } from './mini-chat-store';

export const HEADER_HEIGHT = 40 as const;
export const WIDTHS = {
  full: 320,
  minimized: 240,
  avatar: HEADER_HEIGHT,
} as const;
export const CHAT_HEIGHTS = {
  full: 560,
  minimized: HEADER_HEIGHT,
  avatar: HEADER_HEIGHT,
};
export const CHAT_GAP = 16 as const;

export const useMiniChatBottomStyling = (): number => {
  const { chats, rolledUp } = useMiniChatShallowStore('chats', 'rolledUp');
  const isMobileMiniChats = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const show = !!chats.length && !rolledUp && !isMobileMiniChats;
  return show ? HEADER_HEIGHT : 0;
};
